import { Link } from 'react-router-dom'
import { cn } from 'shared/utils/cn'

interface IProps {
  children: React.ReactNode
  to: string
  themeBranding?: boolean
  className?: string
  onClick?: () => void
  trackingName?: string
  trackingEvent?: string
  tabIndex?: number
}
export const InternalLink = ({
  children,
  to,
  themeBranding,
  className,
  onClick,
  trackingName,
  trackingEvent,
  tabIndex,
}: IProps) => {
  const anchorClasses = cn(
    'flex h-auto items-center gap-1 border-none bg-transparency-full !px-0 font-semibold !text-surface-common-primary underline-offset-2 outline-none',
    'cursor-pointer hover:bg-transparency-full hover:underline',
    'focus:bg-transparent focus-visible:underline',
    'active:border-none active:bg-transparency-full active:!text-text-primary active:underline active:outline-none',
    themeBranding
      ? '!text-text-brand hover:!text-text-brand focus:!text-text-brand'
      : '!text-surface-common-primary hover:!text-surface-common-primary focus:!text-surface-common-primary',
    className
  )

  return (
    <Link
      to={to}
      className={anchorClasses}
      onClick={onClick}
      data-tracking-name={trackingName}
      data-tracking-event={trackingEvent}
      tabIndex={tabIndex}
    >
      {children}
    </Link>
  )
}
